import {
  AssignmentRuleStatusEnum,
  AssignmentRuleStrategyEnum,
  RiskLevelEnum,
} from '../../../shared/models';

export interface DefaultAssignmentRuleConfig {
  name: string;
  position: number;
  status: AssignmentRuleStatusEnum;
  strategy: AssignmentRuleStrategyEnum;
  jsonLogic: Record<string, unknown>;
}

export const DEFAULT_ASSIGNMENT_RULES: DefaultAssignmentRuleConfig[] = [
  {
    name: 'High risk cases escalated to workspace owner',
    position: 1,
    status: AssignmentRuleStatusEnum.enabled,
    strategy: AssignmentRuleStrategyEnum.workload,
    jsonLogic: {
      and: [
        {
          in: [
            { var: 'case.risk.level' },
            [RiskLevelEnum.high, RiskLevelEnum.critical],
          ],
        },
      ],
    },
  },
  // Additional default assignment rules can be added here
  // Example:
  // {
  //   name: 'Medium risk cases round-robin assignment',
  //   position: 2,
  //   status: AssignmentRuleStatusEnum.enabled,
  //   strategy: AssignmentRuleStrategyEnum.round_robin,
  //   jsonLogic: {
  //     and: [
  //       {
  //         in: [
  //           { var: 'case.risk.level' },
  //           [RiskLevelEnum.medium],
  //         ],
  //       },
  //     ],
  //   },
  // },
];
